import { useState } from 'react';
import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { BulkEmailPrefixes } from '@frontend/tracking-prefixes';
import { theme } from '@frontend/theme';
import { Button, NakedButton, Text } from '@frontend/design-system';
import { NEW_CAMPAIGN_ID } from '../../constants';
import { useBulkNavigator } from '../../hooks/use-bulk-navigator';
import { CustomListTemplates } from './custom-list-templates';
import { DefaultListTemplates } from './default-list-templates';

export const BulkEmailTemplates = () => {
  const { t } = useTranslation('bulk-messaging');
  const navigateTo = useBulkNavigator(CampaignType.EMAIL);
  const [selectedView, setSelectedView] = useState<'custom' | 'default'>('custom');
  const [isUpdating, setIsUpdating] = useState(false);

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        rowGap: theme.spacing(3),
      }}
    >
      <div
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
          flexWrap: 'wrap',
          marginTop: theme.spacing(2),
          gap: theme.spacing(2),
        }}
      >
        <div css={{ display: 'flex', gap: theme.spacing(1), flexWrap: 'wrap' }}>
          <Button
            variant='secondary'
            css={[buttonStyle, selectedView === 'custom' && selectedStyle]}
            disabled={isUpdating}
            onClick={() => setSelectedView('custom')}
          >
            {t('Your Templates')}
          </Button>
          <Button
            variant='secondary'
            css={[buttonStyle, selectedView === 'default' && selectedStyle]}
            disabled={isUpdating}
            onClick={() => setSelectedView('default')}
          >
            {t('Default Templates')}
          </Button>
        </div>
        <NakedButton
          css={{ display: 'flex', columnGap: theme.spacing(1) }}
          onClick={() => navigateTo.composer({ templateId: NEW_CAMPAIGN_ID })}
          trackingId={`${BulkEmailPrefixes.Templates}-new-template-btn`}
        >
          <Icon name='plus' color='primary' />
          <Text color='primary'>{t('Create New Template')}</Text>
        </NakedButton>
      </div>
      {selectedView === 'custom' ? <CustomListTemplates setIsUpdating={setIsUpdating} /> : <DefaultListTemplates />}
    </div>
  );
};

const buttonStyle = {
  border: `2px solid ${theme.colors.neutral50}`,
  '&:hover': {
    border: `2px solid ${theme.colors.neutral50}`,
    backgroundColor: theme.colors.white,
  },
};

const selectedStyle = {
  border: `2px solid ${theme.colors.primary50}`,
  backgroundColor: theme.colors.primary5,
  '&:hover': {
    border: `2px solid ${theme.colors.primary50}`,
    backgroundColor: theme.colors.primary5,
  },
};
